

import { defineComponent } from 'vue';
import PopRow from './PopRow.vue';
import { tableRef } from './PopBoard.vue';

export default defineComponent({
  name: 'PopTable',
  data() {
    return {
      // tableRef: tableRef.value,
    };
  },
  components:
  {
    PopRow,
  },
  methods: {
    getTableRef() {
      return tableRef.value;
    },
  },
  
});

